import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getAttendanceStatistics } from '@/service/work/attendanceAnalysis/index';
export default function useRealTimeAttendance(params) {
  var attendanceTotal = ref({
    no_sign_count: 0,
    leave_count: 0,
    leave_days_count: 0,
    leave_early_count: 0,
    require_count: 0,
    absent_count: 0,
    late_count: 0,
    attendance_count: 0,
    absent_from_work: 0
  });
  // 查询时间范围内停机详情
  var getAttendanceAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAttendanceStatistics(params.value);
          case 2:
            data = _context.sent;
            attendanceTotal.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAttendanceAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var attendanceData = computed(function () {
    return [{
      num: attendanceTotal.value.require_count,
      desc: '总考勤人数',
      routeName: ''
    }, {
      num: attendanceTotal.value.attendance_count,
      desc: '已打卡人数',
      routeName: ''
    }, {
      num: attendanceTotal.value.absent_count,
      desc: '未打卡人数',
      routeName: 'AbsentPersonnel'
    }, {
      num: attendanceTotal.value.late_count,
      desc: '迟到',
      routeName: ''
    }, {
      num: attendanceTotal.value.leave_early_count,
      desc: '早退',
      routeName: ''
    }, {
      num: attendanceTotal.value.leave_count,
      desc: '请假',
      routeName: ''
    }];
  });
  return [attendanceData, getAttendanceAsync];
}